module.exports = __webpack_public_path__ + "static/media/two_column_white.e3236ac1.svg";